"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../../../components");

var _hooks = require("../../../hooks");

var _ModifierItemModule = _interopRequireDefault(require("./ModifierItem.module.scss"));

var _visuallyHidden = require("@react-aria/visually-hidden");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ModiifierItem = function ModiifierItem(_ref) {
  var cellType = _ref.cellType,
      name = _ref.name,
      price = _ref.price,
      quantity = _ref.quantity,
      multiSelect = _ref.multiSelect,
      onClick = _ref.onClick,
      increment = _ref.increment,
      decrement = _ref.decrement,
      imgSrc = _ref.imgSrc,
      description = _ref.description,
      isOptionalSingle = _ref.isOptionalSingle;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views;

  var handleClick = isOptionalSingle || !quantity ? onClick : null;
  return /*#__PURE__*/_react["default"].createElement(_components.Box, {
    grid: {
      xs: "1-2",
      sm: "1-3"
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    className: _ModifierItemModule["default"].item,
    onClick: handleClick,
    style: {
      backgroundImage: "url(".concat(imgSrc, ")")
    },
    dataTest: name,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"].name
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"].price
  }, price ? /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, price) : null), description ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"].desc
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, description)) : /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: quantity !== 0
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: multiSelect
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"].selectors
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["quantity-btn"],
    onClick: decrement
  }, "-"), /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.secondary,
    className: _ModifierItemModule["default"].quantity,
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    "aria-live": "polite",
    type: labelTextStyles.tertiary
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity)), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["quantity-btn"],
    onClick: increment
  }, "+"))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: isOptionalSingle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"].remove
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    onClick: onClick
  }, "X"))))));
};

var _default = /*#__PURE__*/_react["default"].memo(ModiifierItem);

exports["default"] = _default;